<template>
  <div
    class="input-field-checkbox py-5 w-fit relative"
    :class="`${disabled ? '' : 'halebop-focus'}`"
  >
    <div aria-live="polite" aria-atomic="true">
      <p v-if="checkedValue" class="sr-only">
        ovan visas studentabonnemang ut som val
      </p>
      <p v-if="!checkedValue" class="sr-only">
        ovan visas vanliga abonnemang ut som val
      </p>
    </div>
    <input
      :id="id"
      v-model="checkedValue"
      :value
      type="checkbox"
      class="appearance-none overflow-hidden absolute focus-visible:outline-none peer"
      :disabled
      :aria-disabled="disabled"
      @click="
        disabled
          ? false
          : (e: any) => emit('onClicked', { value: e.target.checked })
      "
    />
    <label
      :class="[
        `${
          disabled
            ? 'text-text-disabled before:border-border-disabled before:bg-surface-disabled after:border-r-border-disabled after:border-b-border-disabled'
            : 'after:border-r-border-primary after:border-b-border-primary before:peer-checked:bg-surface-success before:peer-checked:hover:bg-surface-action-hover before:hover:bg-surface-action-hover before:border-border-primary before:shadow-[inset_1px_1px_0_1px] before:active:shadow-[inset_-1px_-1px_0_1px]'
        }`,
        `
        text-text-primary
        relative
        cursor-pointer
        text-16-22
        md:text-18-22
        lg:text-20-24
        flex
        items-center
        gap-12
        before:inline-block
        before:bg-surface-action-2
        before:border-solid
        before:border-2
        before:shadow-input
        before:rounded-xl
        before:h-28
        before:w-28
        before:min-w-28
        after:h-11
        after:w-6
        after:left-12
        after:opacity-0
        after:peer-checked:opacity-100
        after:peer-checked:hover:opacity-100
        after:absolute
        after:top-[calc(50% - 0.55rem)]
        after:border-solid
        after:border-r-3
        after:border-b-3
        after:rotate-45
        `,
      ]"
      :for="id"
      >{{ label }}</label
    >
    <p class="pt-8" :class="`${disabled ? 'text-text-disabled' : ''}`">
      {{ labelExtra }}
    </p>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits(['onClicked']);
const id = useId();
defineProps<{
  label: string;
  labelExtra?: string;
  disabled?: boolean;
  value?: boolean;
}>();
const checkedValue = defineModel<boolean>();
</script>

<style scoped lang="scss"></style>
